import React from 'react';
import { Link } from 'react-router-dom';

const CallToAction = () => {
  return (
    <section 
      style={{ 
        textAlign: 'center', 
        padding: '60px 20px', 
        backgroundColor: 'var(--light-red)', 
        borderRadius: '10px', 
        margin: '60px 0' 
      }}
      id="join"
    >
      <h2 style={{ color: 'var(--dark-red)', marginBottom: '20px', fontSize: '2rem' }}>
        Хватит ждать перемен! Пришло время действовать!
      </h2>
      <p style={{ fontSize: '1.2rem', maxWidth: '800px', margin: '0 auto 30px' }}>
        Вступайте в ряды КПРФ – единственной политической силы, последовательно защищающей интересы трудового народа.
      </p>
      <Link to="/howtojoin" className="btn" style={{ padding: '16px 40px', fontSize: '1.1rem' }}>
        Вступить в партию
      </Link>
    </section>
  );
};

export default CallToAction;